import type { FC } from 'react'
import type { LucideIcon } from 'lucide-react'
import { cn } from '@/lib/utils'

interface StatsCardProps {
    title: string
    value: string | number
    subtitle?: string
    icon: LucideIcon
    iconClassName?: string
}

export const StatsCard: FC<StatsCardProps> = ({
    title,
    value,
    subtitle,
    icon: Icon,
    // iconClassName,
}) => {
    return (
        <div className="rounded-lg border bg-card hover:shadow-sm transition-shadow relative h-36 flex flex-col">
            <div className="p-4 flex-1">
                <div className="flex items-center gap-2 mb-4">
                    <div className={cn('', ' text-primary')}>
                        <Icon className="h-5 w-5" />
                    </div>
                    <p className="text-sm font-medium text-muted-foreground uppercase tracking-wide">
                        {title}
                    </p>
                </div>
                <p className="text-3xl font-medium">{value}</p>
            </div>
            {subtitle && (
                <div className="bg-[#E1E4EA] px-4 py-2 rounded-b-lg">
                    <p className="text-xs text-muted-foreground uppercase tracking-wide">
                        {subtitle}
                    </p>
                </div>
            )}
        </div>
    )
}
